/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HTTPLink } from './HTTPLink';
import {
    HTTPLinkFromJSON,
    HTTPLinkFromJSONTyped,
    HTTPLinkToJSON,
    HTTPLinkToJSONTyped,
} from './HTTPLink';

/**
 * 
 * @export
 * @interface CreateExerciseCategoryDTO
 */
export interface CreateExerciseCategoryDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseCategoryDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseCategoryDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExerciseCategoryDTO
     */
    imageId?: string;
    /**
     * 
     * @type {Array<HTTPLink>}
     * @memberof CreateExerciseCategoryDTO
     */
    links: Array<HTTPLink>;
}

/**
 * Check if a given object implements the CreateExerciseCategoryDTO interface.
 */
export function instanceOfCreateExerciseCategoryDTO(value: object): value is CreateExerciseCategoryDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    return true;
}

export function CreateExerciseCategoryDTOFromJSON(json: any): CreateExerciseCategoryDTO {
    return CreateExerciseCategoryDTOFromJSONTyped(json, false);
}

export function CreateExerciseCategoryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExerciseCategoryDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'links': ((json['links'] as Array<any>).map(HTTPLinkFromJSON)),
    };
}

export function CreateExerciseCategoryDTOToJSON(json: any): CreateExerciseCategoryDTO {
    return CreateExerciseCategoryDTOToJSONTyped(json, false);
}

export function CreateExerciseCategoryDTOToJSONTyped(value?: CreateExerciseCategoryDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'links': ((value['links'] as Array<any>).map(HTTPLinkToJSON)),
    };
}

